/*
 *密码登录
*/
import React from 'react'
import './login.less'
import api from '../../api/api.js'
import {API_CONFIG} from '../../api/config.js'
import { Form, Input, Button, Select, Icon, message } from 'antd'
import md5 from 'md5'
import qw from '../../static/img/qw.png'

class Mmdl extends React.Component {
    state = {
        login_loading: false
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    login_loading: true
                })
                // 账号密码登录
                api.sso_account_login({
                    username:values.username,
                    password:md5(values.password)
                }).then(res => {
                    if(res.code === 0) {
                        this.setState({
                            login_loading: false   
                        })
                        document.cookie= `${API_CONFIG.company_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                        sessionStorage.setItem('source',res.content.source);
                        sessionStorage.setItem('access_token', res.content.access_token);
                        sessionStorage.setItem('userInfo',
                        JSON.stringify({
                            mobile: values.username,
                            sms_code:  values.password,
                        }))
                        if (res.content.has_team === 2 ) {
                            //无团队登录成功
                            message.error('您还没有创建企业，请先去注册')
                        }else if(res.content.has_team === 1 && res.content.team.length === 1) {
                            sessionStorage.setItem('team', JSON.stringify(res.content.team))
                            //登录指定团队后台
                            api.get_company_login({
                                access_token: sessionStorage.getItem('access_token'),
                                corp_uuid: res.content.team[0].id,
                                source:sessionStorage.getItem('source')
                            }).then(res=>{
                                this.setState({grounpLoading: false})
                                if(res.code===0) {
                                    sessionStorage.setItem('company_token',res.content.access_token)
                                    document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                                    if(sessionStorage.getItem('market_url')){
                                        let market_url = sessionStorage.getItem('market_url')
                                        window.location.href=`${market_url}`
                                    } else {
                                        window.location.href=`${API_CONFIG.yun_base}`
                                    }
                                }
                            })
                        } else if (res.content.has_team === 1 && res.content.team.length > 1) {
                            //有团队
                            sessionStorage.setItem('team',JSON.stringify(res.content.team));
                            this.props.onSucessLogin(true, res.content.team )
                        }
                    }
                    
                }).catch(err => {
                   
                })
            }
        });
    };
    userInput= () =>{ 
      const username = this.props.form.getFieldValue( 'username' )
      sessionStorage.setItem('username',username)
    };

    // 跳转到企业微信
    goQW = () =>{

        let url = encodeURIComponent(`${API_CONFIG.base}/web/#/login`);
        window.location.href = `${API_CONFIG.weixinBase}/oauth/sso/authorizer?turn_url=${url}`;
    }

    
    render() {
        const { getFieldDecorator } = this.props.form;
        const { login_loading, } = this.state
        return (
            <Form style={{paddingTop: 0}} >
                <Form.Item 
                    className='item'
                >
                    {getFieldDecorator('username', {
                        rules: [
                            { required: true, message: '请输入您的手机号',  pattern: /^1[3456789]\d{9}$/, },
                        ],
                    })(<Input 
                        placeholder='请输入您的手机号' 
                        autoComplete="off"
                        onBlur={() => {
                            this.userInput()
                        }} 
                        />)}
                     <span  className='label'> 手机： </span>
                     <span><img src={require("./../../imgs/mobile.png")} alt=""/></span>
                </Form.Item>
                <Form.Item  className='item'>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: '请输入您的密码'}],
                    })(<Input.Password placeholder='请输入您的密码'  autoComplete="off"/>)}
                    <span  className='label'  > 密码： </span>
                </Form.Item>
                
                <Button 
                    className='register-btn' 
                    onClick={this.handleSubmit} 
                    onKeyDown={(e) => {
                        let event  = e || window.event
                        if(event.keyCode ===  13) {
                                this.handleSubmit()
                        }
                    }}
                    loading={login_loading}
                >登录</Button>
                <Button 
                    className='qw-registre-btn' 
                    onClick={this.goQW} 
                >
                    <img src={qw}/>
                    企业微信登录
                </Button>

                   {/*<span 
                        className='register-type' 
                        style={{cursor:'pointer'}}
                        onClick={() => {
                            this.props.history.push('/register')
                        }}
                    >新用户免费注册</span>*/}
                  <span 
                        className='login-type' 
                        onClick={() => {
                         this.props.setLogintype(true)
                        }}
                    >短信验证码登录</span>
            </Form>
           
       )
    }
}
const WrappedNormalLoginForm = Form.create({  })(Mmdl);
export default WrappedNormalLoginForm;



// WEBPACK FOOTER //
// ./src/pages/login/mmdl.jsx